<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full"
      :visible.sync="modalVisible"
      :loading="loading.content"
      :contentStyle="{'height': '100%'}"
      @cancel="cancel"
      @audit="audit">
    <template #header>
      <template v-if="addOpType">
        添加成本补录单
      </template>
      <template v-if="viewOpType || editOpType">
        {{costSupplement.code}}
        <gj-tag
            type="plain"
            shape="rectangle"
            :color="costSupplement.status | optionColor(CostSupplementEnum.statusOption)">
          {{ costSupplement.status | optionText(CostSupplementEnum.statusOption) }}
        </gj-tag>
      </template>
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          :class="{'form-view-opType': viewOpType}"
          :label-width="'70px'">
        <gj-area-title>基本信息</gj-area-title>
        <template v-if="addOpType || editOpType">
          <el-row>
            <el-col :span="6">
              <el-form-item
                  label="补录类型"
                  prop="costType"
                  :label-width="'80px'"
                  :rules="[$gjRequired('请选择补录类型')]">
                <gj-select
                    v-model="form.costType"
                    :clearable="false"
                    :options="CostSupplementEnum.costTypeOption"
                    width="165px"
                ></gj-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                  label="仓库"
                  prop="warehouseId"
                  :label-width="'70px'"
                  :rules="[$gjRequired('请选择自营仓')]">
                <gj-warehouse-select
                    v-model="form.warehouseId"
                    active
                    :fba="false"
                    :clearable="false"
                ></gj-warehouse-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="备注"
                  prop="memo">
                <gj-input
                    v-model="form.memo"
                    :width="'100%'"
                    placeholder="备注"
                ></gj-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="editOpType && costSupplement.status === CostSupplementEnum.status.REJECTED">
            <el-form-item
                label="驳回理由"
                :label-width="'80px'">
              {{data.rejectedReason | defaultShow}}
            </el-form-item>
          </el-row>
        </template>
        <template v-else-if="viewOpType">
          <gj-desc-group
              :label-width="'90px'"
              style="margin-bottom: 12px;">
            <el-row>
              <el-col :span="8">
                <gj-desc
                    label="补录类型">
                  {{data.costType | optionText(CostSupplementEnum.costTypeOption) | defaultShow}}
                </gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc
                    label="仓库"
                    :content="data.warehouseName">
                </gj-desc>
              </el-col>
              <el-col :span="8">
                <gj-desc
                    label="备注"
                    :content="data.memo | defaultShow">
                </gj-desc>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <gj-desc
                    label="创建时间"
                    :content="data.createTime | defaultShow">
                </gj-desc>
              </el-col>
              <el-col v-if="costSupplement.status === CostSupplementEnum.status.REJECTED"
                      :span="16">
                <gj-desc
                    label="驳回理由"
                    :content="data.rejectedReason | defaultShow">
                </gj-desc>
              </el-col>
            </el-row>
          </gj-desc-group>
        </template>
        <gj-area-title>商品信息</gj-area-title>
        <div v-if="addOpType || editOpType" style="margin-bottom: 10px;">
          <gj-button
              type="primary"
              @click="addProduct"
          >添加产品</gj-button>
        </div>
        <gj-table
          :index="false"
          adaptParent
          :loading="loading.table"
          name="opAssemblyOrder"
          :data="form.items"
          :columns="columns"
          border
          :min-height="400"
          :adapt-height-listen-update="false"
          :offset-height="offsetHeight">
          <template v-slot:sku="{row}">
            <div><gj-text>{{row.productName | defaultShow}}</gj-text></div>
            <div>{{row.sku | defaultShow}}</div>
          </template>
          <!-- 关联单号 -->
          <template v-slot:relevanceCode="{row, index}">
            <el-form-item
                :prop="`items.${index}.relevanceCode`"
                :rules="[
                  $gjRequired('入库单号', ['change']),
                ]"
                   label-width="0px"
                   class="gj-table-item">
                 <gj-select
                     v-model="row.relevanceCode"
                     :clearable="false"
                     placeholder="入库单号"
                     :options="row.relevanceCodeOption"
                     width="155px"
                     class="has-append"
                     @input-option="relevanceCodeInput($event, row)">
                 </gj-select>
                 <gj-tooltip content="选择入库单">
                   <gj-button
                       class="append-select-btn"
                       icon="el-icon-s-unfold"
                       @click="selectInboundOrder(row, index)"
                   ></gj-button>
                 </gj-tooltip>
               </el-form-item>
             </template>
             <!-- 数量 -->
             <template v-slot:quantity="{row}">
               <template v-if="row.relevanceCodeLoading">
                 <gj-icon class="el-icon-loading"></gj-icon>
               </template>
               <template v-else>{{row.quantity | defaultShow}}</template>
             </template>
             <!-- 采购成本 -->
             <template v-slot:newPurchaseCost="{row, index}">
               <template v-if="row.relevanceCodeLoading">
                 <gj-icon class="el-icon-loading"></gj-icon>
               </template>
               <template v-else-if="form.costType === CostSupplementEnum.costType.STORAGE_COST || row.relevanceCode">
                 <el-form-item
                     :prop="`items.${index}.newPurchaseCost`"
                     :rules="[
                  $gjRequired('请输入采购成本', ['change']),
                  $gjReRule(RE.num(2), '最多2位小数的正数')
                ]"
                     label-width="0px"
                     class="gj-table-item">
                   <gj-input
                       v-model="row.newPurchaseCost"
                       :clearable="false"
                       placeholder="采购成本">
                     <template #prepend>{{row.currencySymbol}}</template>
                   </gj-input>
                 </el-form-item>
               </template>
               <template v-else>-</template>
             </template>
             <!-- 到库成本 -->
             <template v-slot:newArriveCost="{row, index}">
               <el-form-item
                   :prop="`items.${index}.newArriveCost`"
                   :rules="[
                  $gjRequired('请输入到库成本', ['change']),
                  $gjReRule(RE.num(2), '最多2位小数的正数')
                ]"
                   label-width="0px"
                   class="gj-table-item">
                 <gj-input
                     v-model="row.newArriveCost"
                     :clearable="false"
                     placeholder="到库成本">
                   <template #prepend>{{row.currencySymbol}}</template>
                 </gj-input>
               </el-form-item>
             </template>
             <!-- 总费用 -->
             <template v-slot:newTotalFee="{row, index}">
               <template v-if="row.relevanceCodeLoading">
                 <gj-icon class="el-icon-loading"></gj-icon>
               </template>
               <template v-else-if="row.relevanceCode">
                 <el-form-item
                     :prop="`items.${index}.newTotalArriveCost`"
                     :rules="[
                    $gjRequired('请输入总费用', ['change']),
                    $gjReRule(RE.num(2), '最多2位小数的正数')
                  ]"
                     label-width="0px"
                     class="gj-table-item">
                   <gj-input
                       v-model="row.newTotalArriveCost"
                       :clearable="false"
                       placeholder="总费用">
                     <template #prepend>{{row.currencySymbol}}</template>
                   </gj-input>
                 </el-form-item>
               </template>
               <template v-else>-</template>
             </template>
             <!-- 总采购成本调整金额 -->
             <template v-slot:newTotalChangePurchaseCost="{row}">
               <template v-if="row.relevanceCodeLoading">
                 <gj-icon class="el-icon-loading"></gj-icon>
               </template>
               <template v-else-if="row.relevanceCode">
                 {{ (row.quantity * (row.newPurchaseCost - row.oldPurchaseCost)) | amount | defaultShow(row.currencySymbol) }}
               </template>
               <template v-else>-</template>
             </template>
             <!-- 总到库成本调整金额 -->
             <template v-slot:newTotalChangeArriveCost="{row}">
               <template v-if="row.relevanceCodeLoading">
                 <gj-icon class="el-icon-loading"></gj-icon>
               </template>
               <template v-else-if="row.relevanceCode">
                 {{ (row.newTotalArriveCost - row.oldTotalArriveCost) | amount | defaultShow(row.currencySymbol) }}
               </template>
               <template v-else>-</template>
             </template>
             <!-- 总采购成本 -->
             <template v-slot:newTotalPurchaseCost="{row}">
               {{ (row.quantity * row.newPurchaseCost) | amount | defaultShow(row.currencySymbol) }}
             </template>
             <!-- 总到库成本 -->
             <template v-slot:newTotalArriveCost="{row}">
               {{ (row.quantity * row.newArriveCost) | amount | defaultShow(row.currencySymbol) }}
             </template>
             <!-- 操作 -->
             <template v-slot:op="{index}">
               <div>
                 <gj-button
                     type="text"
                     @click="deleteItem(index)">
                   删除
                 </gj-button>
               </div>
             </template>
           </gj-table>
      </el-form>
    </template>
    <template #footer>
      <gj-button
          @click="cancel"
      >取消</gj-button>
      <gj-button
          v-if="$permission('costSupplement:audit') && !viewOpType"
          type="primary"
          :loading="loading.audit"
          @click="audit()"
      >提审</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {formDeleteItemMixin, formRuleMixin, modalMixIn, opTypeMixin, responseMixin} from "@/minxins";
  import {isMeaningful, isMeaningless, toFixed} from "@/utils/common";
  import AppAddProductModal from "./add-product-modal";
  import {CostSupplementEnum} from "@/views/modules/warehouse/cost-supplement/enum";
  import {addCostSupplement, getCostSupplementById, getInboundProduct, updateCostSupplement} from "@/api/warehouse";
  import AppSelectInboundOrderModal from "@/views/modules/warehouse/cost-supplement/modal/op/select-inbound-order-modal";

  export default {
    name: "app-op-cost-supplement",
    mixins: [modalMixIn, opTypeMixin, formRuleMixin, formDeleteItemMixin, responseMixin],
    props: {
      costSupplement: {
        default: null
      },
      opType: {
        required: true
      }
    },
    data() {
      return {
        data: {},
        columns: [],
        form: {
          id: null,
          warehouseId: null,
          costType: CostSupplementEnum.costType.INBOUND_COST,
          memo: null,
          items: []
        },
        loading: {
          table: false,
          content: false,
          audit: false
        },
        CostSupplementEnum: CostSupplementEnum
      }
    },
    created() {
      if (this.viewOpType || this.editOpType) {
        this.loading.content = true;
        this.inited = false;
        getCostSupplementById(this.costSupplement.id)
          .then(data => {
            this.data = data;
            this.form.id = data.id;
            this.form.warehouseId = data.warehouseId;
            this.form.costType = data.costType;
            this.form.memo = data.memo;
            this.form.items = data.itemPageVOList.map(vo => {
              const item = {
                id: vo.itemId,
                sku: vo.sku,
                productName: vo.productName,
                smallImageUrl: vo.smallImageUrl,
                relevanceItemId: vo.relevanceItemId,
                relevanceCode: vo.relevanceCode,
                relevanceCodeLoading: false,
                quantity: vo.quantity,
                currencySymbol: vo.currencySymbol,
                currency: vo.currency,
                relevanceVOList: [],
                relevanceCodeOption: [],
                newPurchaseCost: vo.newPurchaseCost,
                newArriveCost: toFixed(vo.newTotalArriveCost / vo.quantity),
                newTotalArriveCost: vo.newTotalArriveCost,
                newTotalPurchaseCost: vo.newTotalPurchaseCost,
                oldPurchaseCost: vo.oldPurchaseCost,
                oldArriveCost: toFixed(vo.oldTotalArriveCost / vo.quantity),
                oldTotalArriveCost: vo.oldTotalArriveCost,
                oldTotalPurchaseCost: vo.oldTotalPurchaseCost,
              };
              // 设置SKU可选关联code
              this.setRelevanceCodeOption(item);
              return item;
            });
            this.$nextTick(() => this.inited = true);
          })
          .complete(() => this.loading.content = false);
      }
    },
    watch: {
      warehouseCostType: {
        handler: function () {
          // 重新选择仓库需清空产品
          // 未初始化数据，则回填初始数据
          if ((this.viewOpType || this.editOpType) && !this.inited) {
            return;
          }
          this.form.items = [];
        }
      },
      'form.costType': {
        handler: function (costType) {
          if (isMeaningful(costType)) {
            const INBOUND_COST = this.form.costType === CostSupplementEnum.costType.INBOUND_COST;
            const STORAGE_COST = this.form.costType === CostSupplementEnum.costType.STORAGE_COST;
            if (this.addOpType || this.editOpType) {
              this.columns = [
                {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px'},
                {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '250px'},
                INBOUND_COST ? {id: 'relevanceCode', header: '关联单号', field: 'slot:relevanceCode', width: '195px'} : null,
                INBOUND_COST ? {id: 'quantity', header: '数量', field: 'slot:quantity', width: '80px', align: 'right'} : null,
                STORAGE_COST ? {id: 'quantity', header: '库存量', field: 'quantity', width: '100px', align: 'right'} : null,
                {id: 'newPurchaseCost', header: '采购成本', field: 'slot:newPurchaseCost', width: '140px'},
                INBOUND_COST ? {id: 'newTotalFee', header: '总费用', field: 'slot:newTotalFee', width: '140px'} : null,
                STORAGE_COST ? {id: 'newArriveCost', header: '到库成本', field: 'slot:newArriveCost', width: '140px'} : null,
                INBOUND_COST ? {id: 'newTotalChangePurchaseCost', header: '总采购成本调整金额', field: 'slot:newTotalChangePurchaseCost', width:'140px', align: 'right'} : null,
                INBOUND_COST ? {id: 'newTotalChangeArriveCost', header:  '总到库成本调整金额', field: 'slot:newTotalChangeArriveCost', width: '140px', align: 'right'} : null,
                STORAGE_COST ? {id: 'newTotalPurchaseCost', header: '总采购成本', field: 'slot:newTotalPurchaseCost', width:'140px', align: 'right'} : null,
                STORAGE_COST ? {id: 'newTotalArriveCost', header:  '总到库成本', field: 'slot:newTotalArriveCost', width: '140px', align: 'right'} : null,
                {id: 'op', header: '操作', field: 'slot:op', width: '60px', fixed: 'right',}
              ].filter(item => isMeaningful(item));
            }
            if (this.viewOpType) {
              this.columns = [
                {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px'},
                {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '250px'},
                INBOUND_COST ? {id: 'relevanceCode', header: '关联单号', field: 'relevanceCode', width: '195px'} : null,
                INBOUND_COST ? {id: 'quantity', header: '数量', field: 'quantity', width: '100px', align: 'right'} : null,
                STORAGE_COST ? {id: 'quantity', header: '库存量', field: 'quantity', width: '100px', align: 'right'} : null,
                {id: 'newPurchaseCost', header: '采购成本', field: 'newPurchaseCost', prefix: 'currencySymbol', width: '100px', align: 'right'},
                INBOUND_COST ? {id: 'newTotalFee', header: '总费用', field: 'newTotalArriveCost', prefix: 'currencySymbol', width: '100px', align: 'right'} : null,
                STORAGE_COST ? {id: 'newArriveCost', header: '到库成本', field: 'newArriveCost', prefix: 'currencySymbol', width: '100px', align: 'right'} : null,
                INBOUND_COST ? {id: 'newTotalChangePurchaseCost', header: '总采购成本调整金额', field: 'slot:newTotalChangePurchaseCost', width:'140px', align: 'right'} : null,
                INBOUND_COST ? {id: 'newTotalChangeArriveCost', header:  '总到库成本调整金额', field: 'slot:newTotalChangeArriveCost', width: '140px', align: 'right'} : null,
                STORAGE_COST ? {id: 'newTotalPurchaseCost', header: '总采购成本', field: 'slot:newTotalPurchaseCost', width:'140px', align: 'right'} : null,
                STORAGE_COST ? {id: 'newTotalArriveCost', header:  '总到库成本', field: 'slot:newTotalArriveCost', width: '140px', align: 'right'} : null,
              ].filter(item => isMeaningful(item));
            }
          }
        },
        immediate: true
      }
    },
    computed: {
      offsetHeight() {
        if (this.editOpType
          && this.costSupplement.status === CostSupplementEnum.status.REJECTED) {
          return 85;
        }
        if (this.viewOpType) {
          return 10;
        }
        return 75;
      }
    },
    methods: {
      relevanceCodeInput(option, item) {
        item.relevanceItemId = option.relevanceItemId;
        item.relevanceCodeLoading = true;
        getInboundProduct({
          model: {
            sku: item.sku,
            warehouseId: this.form.warehouseId,
            relevanceCode: option.text,
            costType: this.form.costType
          },
          current: 1,
          size: 999999
        })
          .then(data => {
            this.setItemFrom(item, data);
          })
          .complete(() => item.relevanceCodeLoading = false);
      },
      // 获取SKU可选关联code
      setRelevanceCodeOption(item) {
        getInboundProduct({
          model: {
            sku: item.sku,
            warehouseId: this.form.warehouseId,
            relevanceCode: item.relevanceCode
          },
          current: 1,
          size: 999999
        })
          .then(data => {
            item.relevanceVOList = data?.relevanceVOList || [];
            item.relevanceCodeOption = item.relevanceVOList.map(e => ({
              id: e.relevanceCode,
              text: e.relevanceCode,
              relevanceItemId: e.relevanceItemId,
            }));
          });
      },
      // 根据查询的产品数据设置Item的值
      setItemFrom(item, data) {
        item.currency = data.currency;
        item.currencySymbol = data.currencySymbol;
        item.newPurchaseCost = data.purchaseCost;
        item.newArriveCost = data.arriveCost;
        item.newTotalArriveCost = toFixed(data.arriveCost * data.quantity,2);
        item.quantity = data.quantity;
        // 存储之前的成本
        item.oldPurchaseCost = data.purchaseCost;
        item.oldArriveCost = data.arriveCost;
        item.oldTotalPurchaseCost = data.purchaseCost * data.quantity;
        item.oldTotalArriveCost = data.arriveCost * data.quantity;
      },
      selectInboundOrder(item, index) {
        this.$gjCreate(AppSelectInboundOrderModal, {
          props: {
            warehouseId: this.form.warehouseId,
            sku: item.sku,
            costType: this.form.costType
          },
          on: {
            select: (data) => {
              const item = this.form.items[index];
              item.relevanceItemId = data.relevanceItemId;
              item.relevanceCode = data.relevanceCode;
              this.setItemFrom(item, data);
            }
          }
        });
      },
      addProduct() {
        if (!this.canAddProduct()) {
          return;
        }
        this.$gjCreate(AppAddProductModal, {
          mountTo: this.mountTo,
          props: {
            warehouseId: this.form.warehouseId,
            costType: this.form.costType,
            hideSkuList: this.form.items.map(item => item.sku)
          },
          on: {
            select: (products) => {
              const STORAGE_COST = this.form.costType === CostSupplementEnum.costType.STORAGE_COST;
              this.form.items = this.form.items.concat(products.map(item => this.mapToItem(item, STORAGE_COST)));
            }
          }
        });
      },
      canAddProduct() {
        if (isMeaningless(this.form.warehouseId)) {
          this.$gjMessage.error('请选择仓库');
          return false;
        }
        return true;
      },
      // 由于库存成本和入库成本逻辑不同，当成本为库存成本时，默认显示成本的值
      mapToItem(item, isStorageCost = false) {
        return {
          sku: item.sku,
          productName: item.productName,
          smallImageUrl: item.smallImageUrl,
          relevanceVOList: item.relevanceVOList,
          relevanceCodeOption: (item.relevanceVOList || []).map(e => ({
            id: e.relevanceCode,
            text: e.relevanceCode,
            relevanceItemId: e.relevanceItemId,
          })),
          relevanceCode: null,
          relevanceCodeLoading: false,
          quantity: isStorageCost ? item.quantity : null,
          currencySymbol: isStorageCost ? item.currencySymbol : null,
          currency: isStorageCost ? item.currency : null,
          newPurchaseCost: isStorageCost ? item.purchaseCost : null,
          newArriveCost: isStorageCost ? item.arriveCost : null,
          newTotalArriveCost: null,
          newTotalPurchaseCost: isStorageCost ? item.purchaseCost * item.quantity : null,
          oldPurchaseCost: isStorageCost ? item.purchaseCost : null,
          oldArriveCost: isStorageCost ? item.arriveCost : null,
          oldTotalPurchaseCost: isStorageCost ? item.purchaseCost * item.quantity : null,
          oldTotalArriveCost: isStorageCost ? item.arriveCost * item.quantity : null,
        };
      },
      audit() {
        if (this.formValidate()) {
          this.loading.audit = true;
          const INBOUND_COST = this.form.costType === CostSupplementEnum.costType.INBOUND_COST;
          Promise.resolve({
            id: this.form.id,
            warehouseId: this.form.warehouseId,
            costType: this.form.costType,
            memo: this.form.memo,
            status: CostSupplementEnum.status.WAIT_REVIEW,
            dtoList: this.form.items.map(item => ({
              id: item.id,
              currency: item.currency,
              sku: item.sku,
              relevanceItemId: item.relevanceItemId,
              relevanceCode: item.relevanceCode,
              quantity: item.quantity,
              // 新成本
              newPurchaseCost: item.newPurchaseCost,
              newTotalPurchaseCost: item.newPurchaseCost * item.quantity,
              newTotalArriveCost: INBOUND_COST
                ? item.newTotalArriveCost
                : item.newArriveCost * item.quantity,
              // 老成本
              oldPurchaseCost: item.oldPurchaseCost,
              oldTotalPurchaseCost: item.oldTotalPurchaseCost,
              oldTotalArriveCost: item.oldTotalArriveCost,
            }))
          })
            .then(params => {
              if (this.addOpType) {
                return addCostSupplement(params);
              }
              if (this.editOpType) {
                return updateCostSupplement(params);
              }
            })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success(this.addOpType ? `提审成功：${res.data}` : '提审成功');
                this.$emit('audited');
                this.$gjDestroy();
              });
            })
            .complete(() => this.loading.audit = false);
        }
      },
      formValidate() {
        if (this.form.items.length === 0) {
          this.$gjMessage.error('请添加产品');
          return false;
        }
        return this.$gjFormValidate();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .has-append /deep/ .el-input__inner {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .append-select-btn {
    padding: 9px 2px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  .form-view-opType{
    /deep/ .el-form-item__label, /deep/.el-form-item__content{
      line-height: 28px;
    }
  }
  /deep/ .el-form{
    height: 100%;
    display: flex;
    flex-direction: column;
    .gj-table{
      flex: 1;
      overflow: auto;
    }
  }
  /deep/ .gj-table--default td.vxe-body--column{
    height: 56px !important;
  }
</style>
